__turbopack_context__.v({
  "header": "WoEbma_header",
  "headerContainer": "WoEbma_headerContainer",
  "headerContainerRoundedTop": "WoEbma_headerContainerRoundedTop",
  "label": "WoEbma_label",
  "tabContainer": "WoEbma_tabContainer",
});
